// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__4drAs","loading":"style_loading__sDSgV","second":"style_second__qV7lG","disabled":"style_disabled__uH3N9","middle":"style_middle__lQwW1"};